import { useWindowDimensions, View } from "@-/com.npmjs.react-native";
import Animated, {
  Easing,
  useAnimatedStyle,
  useReducedMotion,
  useSharedValue,
  withDelay,
  withTiming,
} from "@-/com.npmjs.react-native-reanimated";
import { useEffect } from "react";

const COLORS = ["bg-emerald-400", "bg-amber-400", "bg-sky-400", "bg-rose-400", "bg-violet-400"];

/** Confetti falling once from the top of its parent, which it fills. */
export function ConfettiBurst({ count = 32 }: { count?: number }) {
  const isReducedMotion = useReducedMotion();
  return (
    <View
      accessible={false}
      className="pointer-events-none absolute inset-0 overflow-hidden"
      pointerEvents="none"
    >
      {isReducedMotion
        ? null
        : Array.from({ length: count }, (_, index) => (
            // oxlint-disable-next-line react/no-array-index-key -- The particles are a fixed sequence; each index is one particle for the burst's lifetime.
            <ConfettiParticle index={index} key={index} />
          ))}
    </View>
  );
}

function ConfettiParticle({ index }: { index: number }) {
  const { height, width } = useWindowDimensions();
  const progress = useSharedValue(0);
  useEffect(() => {
    progress.set(
      withDelay(
        (index % 8) * 45,
        withTiming(1, { duration: 1900 + (index % 5) * 130, easing: Easing.out(Easing.quad) }),
      ),
    );
  }, [index, progress]);
  const animatedStyle = useAnimatedStyle(() => ({
    opacity: 1 - Math.max(0, (progress.get() - 0.65) / 0.35),
    transform: [
      {
        translateX:
          (((index * 37) % 101) / 100) * width +
          Math.sin(progress.get() * Math.PI) * ((index % 2 ? 1 : -1) * 45),
      },
      { translateY: -20 + progress.get() * height * 0.8 },
      { rotate: `${progress.get() * (index % 2 ? 560 : -480)}deg` },
    ],
  }));
  return (
    <Animated.View
      accessible={false}
      className={`absolute top-0 left-0 h-3 w-1.5 rounded-xs ${COLORS[index % COLORS.length]}`}
      style={animatedStyle}
    />
  );
}
